var _path, _path2, _path3, _path4, _path5, _path6, _path7;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsCloudformation(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2051,
    height: 2500,
    viewBox: "0 0 256 312",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.491 215.53l2.176 2.47 109.915 31.157.498-19.313-76.98-19.318-3.767-1.359-31.842 6.363",
    fill: "#B7CA9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.505 215.53L127.25 253l-.334-23.156 76.979-19.318 3.355-3.776 32.255 8.78",
    fill: "#B7CA9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.916 83.165l76.979 17.941L237.75 99.5l1.755-3.393L132.25 57.5l-5.334 25.665",
    fill: "#3C4929"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1 210.526l-35.609 5.004-.991-3.697V100l.991-3.893L48.667 98.5l3.433 2.61v109.416",
    fill: "#759C3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.08 83.165L52.1 101.106l-35.609-4.999L17.833 94l110.749-31.52.498 20.685",
    fill: "#3C4929"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.846 0L0 64.531l.061 182.613 127.785 64.497 1.904-2.891v-305L127.846 0zM90.462 237.73l-73.971-22.2V96.107l73.971-22.192V237.73zM203.895 210.526l35.61 5.004L241.5 212V99.5l-1.995-3.393-35.61 5.003v109.416",
    fill: "#4B612C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.846 311.641l128.093-64.493L256 64.536 127.846 0v311.641zm37.687-237.726l73.972 22.192V215.53l-73.972 22.2V73.915z",
    fill: "#759C3E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCloudformation);
export default __webpack_public_path__ + "static/media/aws-cloudformation.cccd9c7cd1534e9061a7cae8af762135.svg";
export { ForwardRef as ReactComponent };